
import HttpClient from '../HttpService';

function listStates() {
    return HttpClient.get(`/geoinfos/states/1`);
}

function listCities(stateId) {
    return HttpClient.get(`/geoinfos/cities/${stateId}`);
}

function searchZipCode(zipcode) {
    return HttpClient.get(`/geoinfos/zipcode/${zipcode}`);
}

export default {
    searchZipCode,
    listStates,
    listCities
}
